import { post } from './ajax';
import { isInMiniProgram } from './mini_program';
// 一些定制客户的专用方法

export const whichCustomizeChannel = () => {
  return window.configDetail?.channel_id;
}

export const customizeCheckCanDownload = async (imageid, uiStore) => {
  // 先检测当前是否为定制项目
  const currentChannel = whichCustomizeChannel();
  if (currentChannel === 510797) { // 大白定制渠道
    // 本地是否有token
    let token = localStorage.getItem('customize_token');
    if (!token) {
      const urlInstance = URL.parse(window.location.href);
      token = urlInstance.searchParams.get('userToken');
    }

    if (token) {
      // 先写入本地存储
      localStorage.setItem('customize_token', token);
      // 请求接口
      let cacheResult = sessionStorage.getItem(`check_${currentChannel}_${imageid}`);
      if (!!cacheResult) {
        return [null, true];
      }

      let result = await post('/api/v2/open/510797/checkusercan', {
        userToken: token,
        action: `image/download`,
        extra: {
          imageId: Number(imageid),
          externalSourceId: window.gallery?.external_source_id || ""
        }
      });

      if (!result.success) {
        if (isInMiniProgram()) {
          uiStore.showAlert({
            title: `提醒`,
            content: result.message,
            buttons: [
              {
                label: `取消`,
                onClick: () => {
                  uiStore.hideAlert();
                }
              },
              {
                label: `点击前往`,
                onClick: () => {
                  if (result.data) {
                    const { path, type = 'navigateTo' } = result.data;
                    if (path) {
                      if (window.wx && window.wx.miniProgram) {
                        window.wx.miniProgram[type]?.({
                          url: path
                        });
                      }
                    }
                  }
                }
              }
            ]
          })
        } else {
          uiStore.showToast({
            content: '请在轻功小程序中打开'
          });
        }
      } else {
        sessionStorage.setItem(`check_${currentChannel}_${imageid}`, true);
      }

      return [result.success ? null : result.message, result.success, result.data];
    }

    return [`ERROR`, false];
  }

  return [null, true];
};